import { List, Map } from 'immutable'
import { browserHistory } from 'react-router'

import superAdminService from '../services/super-admin'
import { setError } from './error'

const FETCH_TRANSLATIONS = 'super-admin/FETCH_TRANSLATIONS'
const FETCH_BASE_TRANSLATIONS = 'super-admin/FETCH_BASE_TRANSLATIONS'
const FETCH_ACCOUNTS = 'super-admin/FETCH_ACCOUNTS'
const FETCH_ORGANISATION = 'super-admin/FETCH_ORGANISATION'
const FETCH_ORGANISATIONS = 'super-admin/FETCH_ORGANISATIONS'
const FETCH_USAGE_LOG_SUMMARY = 'super-admin/FETCH_USAGE_LOG_SUMMARY'

export const UPDATE_ORGANISATION_SUCCESS = 'super-admin/UPDATE_ORGANISATION_SUCCESS'
export const DELETE_ORGANISATION_SUCCESS = 'super-admin/DELETE_ORGANISATION_SUCCESS'

const defaultState = Map({
  language: '',
  prefix: '',
  translations: Map(),
  translationsInEnglish: Map(),
  accounts: List(),
  organisations: List(),
  organisation: null,
  usageLog: List()
})

export default function(state = defaultState, action = undefined) {
  switch (action.type) {
    case FETCH_TRANSLATIONS:
      return state
        .update('language', translations => action.payload.language)
        .update('prefix', prefix => action.payload.prefix)
        .update('translations', translations => action.payload.translations)

    case FETCH_BASE_TRANSLATIONS:
      return state.update('translationsInEnglish', translations => action.payload.translations)

    case FETCH_ACCOUNTS:
      return state.update('accounts', accounts => List(action.payload.accounts))

    case FETCH_ORGANISATION:
      return state.update('organisation', organisation => action.payload.organisation)

    case FETCH_ORGANISATIONS:
      return state.update('organisations', organisations => List(action.payload.organisations))

    case FETCH_USAGE_LOG_SUMMARY:
      return state.update('usageLog', summaries => List(action.payload.summary))

    default:
      return state
  }
}

export function selectTranslatableLanguage(language, prefix) {
  return function d(dispatch) {
    if (!language || !prefix) {
      return dispatch({ type: FETCH_TRANSLATIONS, payload: defaultState })
    }

    superAdminService
      .getTranslationsForLanguage(language, prefix)
      .then(data => dispatch({ type: FETCH_TRANSLATIONS, payload: data.data }))
      .catch(() => dispatch({ type: FETCH_TRANSLATIONS, payload: defaultState }))

    superAdminService
      .getTranslationsForLanguage('en', prefix)
      .then(data => dispatch({ type: FETCH_BASE_TRANSLATIONS, payload: data.data }))
      .catch(() => dispatch({ type: FETCH_BASE_TRANSLATIONS, payload: defaultState }))
  }
}

export function updateTranslationsForLanguage(language, prefix, translations) {
  return function d(dispatch) {
    superAdminService.updateTranslationsForLanguage(language, prefix, translations)
  }
}

export function searchAccounts() {
  return function d(dispatch) {
    superAdminService
      .getAccounts()
      .then(data => dispatch({ type: FETCH_ACCOUNTS, payload: data.data }))
  }
}

export function fetchOrganisation(id) {
  return function d(dispatch) {
    dispatch({ type: FETCH_ORGANISATION, payload: {} })

    superAdminService
      .getOrganisation(id)
      .then(data => dispatch({ type: FETCH_ORGANISATION, payload: data.data }))
  }
}

export function fetchOrganisations() {
  return function d(dispatch) {
    superAdminService
      .getOrganisations()
      .then(data => dispatch({ type: FETCH_ORGANISATIONS, payload: data.data }))
  }
}

export function addOrganisation(name, notes, unitPriceWopi, creditsWopi, creditsWopi360) {
  return dispatch => {
    superAdminService
      .addOrganisation(name, notes, unitPriceWopi, creditsWopi, creditsWopi360)
      .then(() => browserHistory.push('/admin/organisations'))
  }
}

export function updateOrganisation(
  id,
  name,
  notes,
  unitPriceWopi,
  addCreditsWopi,
  addCreditsWopi360
) {
  return dispatch => {
    superAdminService
      .updateOrganisation(id, name, notes, unitPriceWopi, addCreditsWopi, addCreditsWopi360)
      .then(response => {
        dispatch({
          type: UPDATE_ORGANISATION_SUCCESS,
          payload: {
            id,
            creditsWopi: response.data.creditsWopi,
            creditsWopi360: response.data.creditsWopi360
          }
        })

        browserHistory.push('/admin/organisations')
      })
  }
}

export function deleteOrganisation(id) {
  return dispatch => {
    superAdminService.deleteOrganisation(id).then(() => {
      dispatch({
        type: DELETE_ORGANISATION_SUCCESS,
        payload: {
          id
        }
      })

      browserHistory.push('/admin/organisations')
    })
  }
}

export function addAccount(email, givenName, familyName, organisationId, language, roles) {
  return function d(dispatch) {
    superAdminService
      .addAccount(email, givenName, familyName, organisationId, language, roles)
      .then(() => browserHistory.push('/admin/accounts'))
      .catch(data => {
        if (data.data.error === 'duplicate_email') {
          setError('duplicate_email')(dispatch)
        }
      })
  }
}

export function fetchUsageSummary(year, month) {
  return function d(dispatch) {
    if (!year || !month) {
      return dispatch({ type: FETCH_USAGE_LOG_SUMMARY, payload: [] })
    }

    superAdminService
      .getUsageLogSummary(year, month)
      .then(data => dispatch({ type: FETCH_USAGE_LOG_SUMMARY, payload: data.data }))
  }
}



// WEBPACK FOOTER //
// ./src/ducks/super-admin.js